import React from 'react'
import { WithRouterProps } from 'react-router'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import {
  ProductCarousel,
  ProductCarouselList,
  ProductCarouselTitle,
} from '@/checkout-instore-legacy/components/ProductCarousel'
import { ShowTogetherProductsItem } from './ShowTogetherProductsItem'
import { Button, csx } from '@vtex/admin-ui'
import { useShowTogetherProducts } from './hooks'
import { FormattedMessage } from 'react-intl'
import { getCurrencyCode } from '@/checkout-instore-legacy/utils/PaymentUtils'
import { normalizePrice } from './utils'
import { useIntl } from '@/checkout-instore-legacy/hooks/intl'

export type ShowTogetherProductsSectionProps = {
  sku: Item
  // TODO: this error popped up when moving the checkout-instore project
  // to checkout-instore-legacy, but needs to be fixed at some point
  // @ts-ignore
} & WithRouterProps

export const ShowTogetherProductsSection = withRouter(
  ({ router, sku }: ShowTogetherProductsSectionProps) => {
    const currencyCode = getCurrencyCode() ?? 'BRL'
    const { locale } = useIntl()

    const {
      showTogetherProducts,
      selectedItems,
      totalPrice,
      selectItem,
      addSelectedProductsToCart,
    } = useShowTogetherProducts({ sku, router })

    const canShowBuyTogetherButton = Object.keys(selectedItems).length > 1

    if (showTogetherProducts.length <= 1) {
      return null
    }

    return (
      <div
        className={csx({
          background: '$white',
          paddingY: '$space-8',
        })}
      >
        <ProductCarousel
          className={csx({
            maxWidth: '96rem',
            marginX: 'auto',
          })}
        >
          <ProductCarouselTitle>
            <FormattedMessage id="showTogether.title" />
          </ProductCarouselTitle>
          <ProductCarouselList
            mobileCardSize="11rem"
            desktopProductsPerPage={5}
          >
            {showTogetherProducts.map((item) => (
              <ShowTogetherProductsItem
                key={item.id}
                item={item}
                isChecked={!!selectedItems[item.id]}
                isMainItem={sku?.id === item.id}
                handleItemClick={() => selectItem(item)}
              />
            ))}
          </ProductCarouselList>
        </ProductCarousel>
        <div
          className={csx({
            display: 'flex',
            justifyContent: 'center',
            marginTop: '$space-8',
          })}
        >
          <Button
            data-testid="product-page-add-to-cart-together"
            disabled={!canShowBuyTogetherButton}
            onClick={addSelectedProductsToCart}
          >
            <FormattedMessage
              id="showTogether.buyButton"
              values={{
                total: Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency: currencyCode,
                }).format(normalizePrice(totalPrice)),
              }}
            />
          </Button>
        </div>
      </div>
    )
  }
)
